import { render, staticRenderFns } from "./FileCard.vue?vue&type=template&id=003e790f&"
import script from "./FileCard.vue?vue&type=script&lang=ts&"
export * from "./FileCard.vue?vue&type=script&lang=ts&"
import style0 from "./FileCard.vue?vue&type=style&index=0&id=003e790f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports